var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-pin';
                    var viewUrl = 'sprite.svg#view-icon-pin';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };